/** Analytics stat of type project count */

/** Analytics stat of type project sqft */

/** Analytics stat of type project 360 images */

/** Analytics stat of type project sheets */

/** Analytics stat of data type cumulative (absolute) */

/** Analytics stat of data type differential */

/** List of chart titles */
export let ChartTitle = /*#__PURE__*/function (ChartTitle) {
  ChartTitle["project"] = "Total projects over time";
  ChartTitle["projectSqft"] = "Total sqFt over time";
  ChartTitle["projectSpheres"] = "Total 360\xBA images over time";
  ChartTitle["projectSheets"] = "Total sheets over time";
  return ChartTitle;
}({});

/** List of chart dataset legends */
export let ChartLegend = /*#__PURE__*/function (ChartLegend) {
  ChartLegend["projectNew"] = "New projects";
  ChartLegend["projectExisting"] = "Existing projects";
  ChartLegend["projectSqftNew"] = "Newly allocated sqft";
  ChartLegend["projectSqftExisting"] = "Used sqft";
  ChartLegend["projectSpheresNew"] = "New 360\xBA images";
  ChartLegend["projectSpheresExisting"] = "Existing 360\xBA images";
  ChartLegend["projectSheetsNew"] = "New sheets";
  ChartLegend["projectSheetsExisting"] = "Existing sheets";
  ChartLegend["defaultNew"] = "New";
  ChartLegend["defaultExisting"] = "Existing";
  return ChartLegend;
}({});

/** List of chart types */
export let ChartType = /*#__PURE__*/function (ChartType) {
  ChartType["project"] = "project-count";
  ChartType["projectSqft"] = "project-sqft";
  ChartType["projectSpheres"] = "project-spheres";
  ChartType["projectSheets"] = "project-sheets";
  return ChartType;
}({});

/** Project chart types  */

/** Valid month strings for data labels */
export let ChartMonth = /*#__PURE__*/function (ChartMonth) {
  ChartMonth["jan"] = "Jan";
  ChartMonth["feb"] = "Feb";
  ChartMonth["mar"] = "Mar";
  ChartMonth["apr"] = "Apr";
  ChartMonth["may"] = "May";
  ChartMonth["jun"] = "Jun";
  ChartMonth["jul"] = "Jul";
  ChartMonth["aug"] = "Aug";
  ChartMonth["sep"] = "Sep";
  ChartMonth["oct"] = "Oct";
  ChartMonth["nov"] = "Nov";
  ChartMonth["dec"] = "Dec";
  return ChartMonth;
}({});

/** Interface for a pairs of stats used to process the backend stats */

/** Interface for valid stat pairs where both cumulative and differential stats are defined */

/** Record of stat pairs */

/** Sets of chart data  */

/** Interface for the chart data */